export const initialState = {
	selectedArea: undefined,
	selectedAreaChangesClone: undefined
};

export default initialState;
